import React from "react";
export default function ResultSection({ title, action, }) {
    return (<div className="flex items-center justify-between">
      <div className="text-sm font-semibold uppercase text-[#A1A2A5]">
        {title}
      </div>
      {action}
    </div>);
}
